import React from "react";

const Shop = () => {
	return <div></div>;
};

export default Shop;
